<template>
  <div>
    <v-btn fab :small="$vuetify.breakpoint.smAndUp" :x-small="!$vuetify.breakpoint.smAndUp" depressed class="primary lighten-1" @click="$emit('decrement')" :disabled="min >= value">
      <v-icon class="transparent">mdi-minus</v-icon>
    </v-btn>
    <span class="mx-3 font-weight-bold text-subtitle-2 primary--text text--darken-1 fix-num-width">{{ value }}</span>
    <v-btn fab :small="$vuetify.breakpoint.smAndUp" :x-small="!$vuetify.breakpoint.smAndUp" depressed class="primary lighten-2" @click="$emit('increment')" :disabled="max > 0 && value >= max">
      <v-icon class="transparent">mdi-plus</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number
    },
    max: {
      type: Number
    },
    min: {
      type: Number
    }
  }
}
</script>

<style></style>
